module.exports = __webpack_public_path__ + "img/icon3.44ed465.png";